import React, { useCallback, useContext } from 'react';

import { StorehouseDefinitionsContext } from '../../storehouse-definitions.context';
import StorehouseDefinitionsForm from '../Form/StorehouseDefinitionsForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(StorehouseDefinitionsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <StorehouseDefinitionsForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
